export default "__VITE_ASSET__DYCBX8G5__"